import Conf from './config';
import { Request, RequestAbsConfig, RequestHttp } from './core';
import { qs } from './qs';
import Taro, {
  getSystemInfoSync as TaroGetSystemInfoSync,
  hideNavigationBarLoading as TaroHideNavigationBarLoading,
  request as TaroRequest,
  showNavigationBarLoading as TaroShowNavigationBarLoading,
  showToast as TaroShowToast,
  showLoading,
} from '@tarojs/taro';

import {
  getLocalStorage,
  STORE_KEYS,
  setLocalStorage,
  removeLocalStorage,
} from '@/tool/localStore';

// app框架，支持uni、Taro

// app全局通信方法
const xAppEmit = (eventName: string, ...args: any[]) => {
  Taro.eventCenter.trigger(eventName, ...args);
};

// http请求参数
type RequestOptions = Taro.request.Option;

// http请求成功类型
type RequestSuccessCallbackResult = Taro.request.SuccessCallbackResult;

// 获取app平台
let appPlatform: string =
  process.env.TARO_ENV ||
  Taro.ENV_TYPE ||
  process.env.UNI_PLATFORM ||
  process.env.VUE_APP_PLATFORM;

console.log('获取app平台', appPlatform);
// console.log(Taro);

const request = Taro.request || TaroRequest;
const showToast = Taro.showToast || TaroShowToast;
const getSystemInfoSync = Taro.getSystemInfoSync || TaroGetSystemInfoSync;

let showNavigationBarLoading: () => void;
let hideNavigationBarLoading: () => void;
if (process.env.TARO_ENV !== 'h5') {
  showNavigationBarLoading =
    Taro.showNavigationBarLoading || TaroShowNavigationBarLoading;
  hideNavigationBarLoading =
    Taro.hideNavigationBarLoading || TaroHideNavigationBarLoading;
}

// 请求配置
class RequestConfig extends RequestAbsConfig {
  /**
   * 显示加载
   */
  showLoading() {
    if (showNavigationBarLoading) {
      showNavigationBarLoading();
    }
  }
  /**
   * 隐藏加载
   */
  hideLoading() {
    if (hideNavigationBarLoading) {
      hideNavigationBarLoading();
    }
  }
  /**
   * 错误业务处理
   */
  failHandle(response: RequestSuccessCallbackResult) {
    console.log('处理错误xxx', response);

    if (response.statusCode < 500 && response.statusCode >= 400) {
      showToast({
        title: `访问受限 Code-${response.statusCode}`,
        icon: 'none',
        duration: 2000,
      });
      return;
    } else if (response.statusCode < 600 && response.statusCode >= 500) {
      showToast({
        title: `抱歉，服务器开小差了 Code-${response.statusCode}`,
        icon: 'none',
        duration: 2000,
      });
    } else if (response.statusCode == 4002) {
      removeLocalStorage(STORE_KEYS.token);
      removeLocalStorage('authFlag');
    } else {
      showToast({
        title: '请求数据失败,请检查网络是否正常',
        icon: 'none',
        duration: 2000,
      });
    }
    console.log('进来');
    //token过期
    // removeLocalStorage(STORE_KEYS.token);
    removeLocalStorage('authFlag');
    // Taro.reLaunch({
    //   url: `/pages/authority-center/index?flag=0`,
    // });
  }
  /**
   * 成功业务处理
   */
  successHandle(res: any, isMessage: boolean) {
    if (res.code == 4002) {
      removeLocalStorage(STORE_KEYS.token);
      removeLocalStorage('authFlag');
      return;
    }
    if ('code' in res && res.code * 1 !== 0) {
      if ([10005, 10006].includes(res.code)) {
        //exitSystem(url, true) //自动退出系统
        xAppEmit('exitSystem', 1);
        if (isMessage) {
          showToast({
            title: '您还未登录，请登录',
            icon: 'none',
            duration: 2000,
          });
        }
        return;
      }
      if (isMessage) {
        showToast({
          title: res.msg || '未知错误',
          icon: 'none',
          duration: 2000,
        });
      }
    }
  }
  /**
   * 请求之前
   */
  // 在请求拦截器中，仅在同时缺失token和flag时跳转
  beforeRequest(requestOption) {
    const _token = getLocalStorage(STORE_KEYS.token);
    if (!_token) {
      const currentPage = Taro.getCurrentPages().pop()?.route;
      if (currentPage !== '/pages/authority-center/index') {
        Taro.reLaunch({ url: '/pages/authority-center/index?flag=0' });
      }
      return;
    }
    // const _token = "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NTY0Njg5NjUsImlhdCI6MTc1NTE3Mjk2NSwidG9rZW5fY2xhaW0iOnsiY3VycmVudFVzZXIiOiJ7XCJsb2dpbkFjY291bnRcIjpcImxpamllXCIsXCJ0aGlyZFBhcnR5VHlwZVwiOlwiZmVpU2h1XCIsXCJjb3VudHJ5TW9iaWxlXCI6XCIrODYxNzYwODQyNDU3NVwiLFwidXNlcklkXCI6XCIyYzkxODA4ODk0NzQyMjgwMDE5NDc0ZTU1MGUxMDAwZlwiLFwicmVhbE5hbWVcIjpcIuadjuadsOadsFwiLFwidGhpcmRQYXJ0eVZvdWNoZXJcIjpcIjE3NjA4NDI0NTc1XCIsXCJwaG9uZVwiOlwiMTc2MDg0MjQ1NzVcIixcInRva2VuVHlwZVwiOlwiZmVpU2h1XCJ9In19.q7w1OkXmGx0x4SM6__i6iCIC6Nzqa4k2kitfUAiWUVU"




    setLocalStorage('authToken', _token);
    if (requestOption) {
      requestOption.header = requestOption.header || {};
      requestOption.header['Authorization'] = _token || '';
    }
  }
  /**
   * 请求之后
   */
  afterRequest() { }
}

/**
 * 配置请求核心方法
 */
const reqConfig = new RequestConfig({
  errorResponseIntercept(result) {
    if (Array.isArray(result)) {
      // 登录过期
      return result[0]; // vue2 中 uni.request第一个是错误响应信息
    } else {
      if (result?.data?.code === '4002') {
        showToast({
          title: result?.data?.msg,
          icon: 'none',
          duration: 2000,
        });
        setTimeout(() => {
          Taro.reLaunch({
            url: `/pages/authority-center/index?flag=0`,
          });
        }, 2000);
      }
    }
    // return result;
  },
  responseIntercept(result) {
    if (Array.isArray(result)) {
      return result[1]; // vue2 中 uni.request第二个是正常响应信息
    }
    return result;
  },
});

//获取token
export const AppSysinfo: { [x: string]: any } = {};

try {
  const res = getSystemInfoSync();
  AppSysinfo.model = res.model;
  AppSysinfo.language = res.language;
  AppSysinfo.screen = `${res.windowWidth}*${res.windowHeight}*${res.pixelRatio}`;
  AppSysinfo.system = res.system;
  AppSysinfo.version = res.version || ''; // 微信版本
  AppSysinfo.SDKVersion = res.SDKVersion || ''; // 小程序或SDK版本
  // AppSysinfo.deviceId = res.deviceId;
  appPlatform += `;${res.platform}`;
} catch (e) {
  // error
}

export const useFormData = (formData: any) => {
  const formDataBody = new FormData();
  Object.keys(formData).forEach(key => {
    if (formData[key] instanceof Array) {
      formData[key].forEach(item => {
        if (item !== '') formDataBody.append(key, item);
      });
      return;
    }
    if (formData[key] !== '') formDataBody.append(key, formData[key]);
  });
  console.log('formDataBody', formDataBody);
  return formDataBody;
};

const Http = new RequestHttp<Request, Partial<RequestOptions>>({
  request: request as unknown as Request,
  baseDomain: Conf.domain,
  requestConfig: reqConfig,
  requestOption: {
    header: {
      'Com-App-Platform': appPlatform,
      'Com-App-Language': AppSysinfo.language || '',
      'Com-App-Sysinfo': qs.stringify(AppSysinfo),
    },
  },
});

export function httpGet<T = any>(path: string, domain?: string) {
  return Http.create<T>(path, 'GET', domain);
}

export function httpPost<T = any>(path: string, domain?: string) {
  return Http.create<T>(path, 'POST', domain);
}
export function httpDel<T = any>(path: string, domain?: string) {
  return Http.create<T>(path, 'DELETE', domain);
}
export function httpPut<T = any>(path: string, domain?: string) {
  return Http.create<T>(path, 'PUT', domain);
}
